export default class NavigationService {
    mobileViewLinks = undefined;

    static addLinksToMobileView(linksFragment) {
        this.mobileViewLinks = linksFragment;
    }
}
